<div class="assignment-list-container" *transloco="let t; prefix: 'vehicleAssignment.list'">
  <div class="header">
    <div class="driver">
      <a class="d-inline-block" [routerLink]="['/driver-management/driver-vehicle-assignment']">
        <h2 class="d-flex align-items-center gap-2 m-0 h3">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M20.9999 11H6.41394L11.7069 5.70697L10.2929 4.29297L2.58594 12L10.2929 19.707L11.7069 18.293L6.41394 13H20.9999V11Z"
              fill="#9FA1A4" />
              </svg><span>{{ fullName }}</span>
            </h2>
          </a>
        </div>
        <div class="search-vehicles">
          <app-search [placeholder]="t('searchPlaceholder')" [disabled]="isLoading"
          (searchTermUpdated)="onSearchTermUpdate($event)"></app-search>
        </div>

        <app-custom-dropdown [options]="assignmentOptions" [selected]="selectedAssignment"
        (selectedOption)="selectAssignment($event)"></app-custom-dropdown>

        <div class="driver-search-filter">
          <app-account-filter [filter]="accountFilter" class="w-50 py-2"
          (filterChanged)="onAccountFilterChange($event)"></app-account-filter>
        </div>
      </div>

      <div class="assigned-vehicles-table">
        <table class="table">
          <thead>
            <tr>
              @if (hasFleetManagerRole  && !isDriverDeleted) {
                <th class="p-3 checkbox-column">
                  @if (getSelectionState() === 'none') {
                    <button type="button" class="selection-toggle-btn" (click)="toggleAllSelection()">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#DADADE" stroke-linejoin="round"/>
                      </svg>
                    </button>
                  }
                  @if (getSelectionState() === 'partial') {
                    <button type="button" class="selection-toggle-btn" [disabled]="isLoading" (click)="toggleAllSelection()">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#EE2737"/>
                        <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#EE2737"/>
                        <line x1="4.5" y1="8" x2="11.5" y2="8" stroke="white" stroke-width="2" stroke-linecap="round"/>
                      </svg>
                    </button>
                  }
                  @if (getSelectionState() === 'all') {
                    <button type="button" class="selection-toggle-btn" [disabled]="isLoading" (click)="toggleAllSelection()">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#EE2737"/>
                        <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#EE2737"/>
                        <path d="M2.95312 8.85384L6.28646 11.9788L12.9531 3.64551" stroke="white" stroke-width="2" stroke-linejoin="round"/>
                      </svg>
                    </button>
                  }
                </th>
              }
              <th class="p-3">{{ t('assetName') }}</th>
              <th class="p-3">{{ t('plateNumber') }}</th>
              <th class="p-3">{{ t('make') }}</th>
              <th class="p-3">{{ t('model') }}</th>
              <th class="p-3">{{ t('assignmentDate') }}</th>
              <th class="p-3" [ngClass]="{'text-center': hasFleetManagerRole && !isDriverDeleted}">{{ t('action') }}</th>
            </tr>
          </thead>
          @if (isLoading) {
            <tbody>
              <tr>
                <td colspan="7">
                  <div class="spinner-container">
                    <span class="spinner-border text-light"></span>
                  </div>
                </td>
              </tr>
            </tbody>
          }
          @if (!isLoading) {
            <tbody>
              @if (hasLoaded && !assignedVehicles?.length) {
                <div class="no-data">
                  <span>{{ 'common.noDataFound' | transloco }}</span>
                </div>
              }
              @for (vehicle of assignedVehicles; track vehicle) {
                <tr>
                  @if (hasFleetManagerRole && !isDriverDeleted) {
                    <td class="p-3 checkbox-column">
                      <input type="checkbox" [checked]="selectedVehicleIds.has(vehicle.assetId)" (change)="onRowSelectionChange(vehicle.assetId, $event)">
                    </td>
                  }
                  <td class="p-3 vehicle-name">
                    <span [ngbTooltip]="(vehicle.assetName.length > 20 ? vehicle.assetName : null)">
                      {{ vehicle.assetName | truncatetext:20 }}
                    </span>
                  </td>
                  <td class="p-3">{{ vehicle.plateNumber || ' - '}}</td>
                  <td class="p-3">{{ vehicle.make || ' - '}}</td>
                  <td class="p-3">{{ vehicle.model || ' - '}}</td>
                  <td class="p-3">
                    {{ vehicle.assignmentDate ? (vehicle.assignmentDate | date: 'yyyy/MM/dd HH:mm') : ' - '}}
                  </td>
                  <td class="p-3">
                    <div class="action-container" [ngStyle]="hasFleetManagerRole && !isDriverDeleted ? {'justify-content': 'end'} : {}">
                      @if (!vehicle.isSynced) {
                        <div class="pending-label">
                          <span class="pending-label-text">{{ 'common.pending' | transloco }}</span>
                        </div>
                      }
                      @if (hasFleetManagerRole && !isDriverDeleted) {
                        @if (isActive(assignmentFilterType.Assigned)) {
                          <button type="button" class="single-action-button" [disabled]="selectedVehicleIds.size > 0" (click)="handleSingleUnassignmentModal(vehicle)">{{ 'common.unassign' | transloco }}</button>
                        }
                        @if (isActive(assignmentFilterType.PendingAssignment)) {
                          <button type="button" class="single-action-button" [disabled]="selectedVehicleIds.size > 0" (click)="cancelPendingSingleAssignmentModal(vehicle)">{{ t('cancelAssignment') }}</button>
                        }
                        @if (isActive(assignmentFilterType.PendingUnassignment)) {
                          <button type="button" class="single-action-button" [disabled]="selectedVehicleIds.size > 0" (click)="cancelPendingSingleUnassignmentModal(vehicle)">{{ t('cancelUnassignment') }}</button>
                        }
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
        </table>
        @if (!isLoading && assignedVehicles.length > 0) {
          <div class="pagination-container p-3">
            <div class="items-lbl">{{ 'common.showingOutOf' | transloco: { current: currentItems, total: totalItems } }}</div>
            <app-pagination [totalPages]="numberOfPages" [currentPage]="currentPage"
              (pageChange)="createPagination($event)">
            </app-pagination>
            <div class="bulk-action-button-container" [ngStyle]="{'visibility': hasFleetManagerRole && !isDriverDeleted ? 'visible' : 'hidden'}">
              @if (isActive(assignmentFilterType.Assigned)) {
                <button type="button" class="bulk-action-button" [disabled]="selectedVehicleIds.size < 1" (click)="handleBulkUnassignmentModal()"> {{ t('bulkUnassign') }} </button>
              }
              @if (isActive(assignmentFilterType.PendingAssignment)) {
                <button type="button" class="bulk-action-button" [disabled]="selectedVehicleIds.size < 1" (click)="cancelBulkAssignmentModal()"> {{ t('bulkCancellation') }} </button>
              }
              @if (isActive(assignmentFilterType.PendingUnassignment)) {
                <button type="button" class="bulk-action-button" [disabled]="selectedVehicleIds.size < 1" (click)="cancelBulkUnassignmentModal()"> {{ t('bulkCancellation') }} </button>
              }
            </div>
          </div>
        }
      </div>
    </div>